import React from 'react';
import { Card as MantineCard, Text, Title, Group, Box, MantineSpacing } from '@mantine/core';

interface CardProps {
  children: React.ReactNode;
  className?: string; // className might be used for Tailwind-like utility classes from App.tsx
  // Add other props if App.tsx passes them to Card, e.g., shadow, padding, radius
  [key: string]: any; // Allow any other MantineCard props
}

export const Card = ({ children, className, ...props }: CardProps) => (
  <MantineCard shadow="sm" padding="lg" radius="md" withBorder className={className} {...props}>
    {children}
  </MantineCard>
);

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
  py?: MantineSpacing; // Allow padding y prop
  [key: string]: any; // Allow other props
}

export const CardHeader = ({ children, className, py = 'xs', ...props }: CardHeaderProps) => (
  // Mantine Card.Section can be used for headers/footers or use Group for flexible layouts
  <MantineCard.Section withBorder inheritPadding py={py} className={className} {...props}>
    <Group justify="space-between">
      {children}
    </Group>
  </MantineCard.Section>
);

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  [key: string]: any; // Allow other props
}

export const CardTitle = ({ children, className, order = 3, ...props }: CardTitleProps) => (
  <Title order={order} className={className} {...props}>{children}</Title> // Using Mantine Title
);

interface CardDescriptionProps {
  children: React.ReactNode;
  className?: string;
  [key: string]: any; // Allow other props
}

export const CardDescription = ({ children, className, ...props }: CardDescriptionProps) => (
  <Text size="sm" c="dimmed" className={className} {...props}>{children}</Text> // Using Mantine Text
);

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
  pt?: MantineSpacing; // Explicitly allow pt
  p?: MantineSpacing; // Explicitly allow p and other spacing props
  px?: MantineSpacing;
  py?: MantineSpacing;
  pb?: MantineSpacing;
  pl?: MantineSpacing;
  pr?: MantineSpacing;
  mt?: MantineSpacing;
  mb?: MantineSpacing;
  style?: React.CSSProperties;
  [key: string]: any; // Allow other Box props
}

export const CardContent = ({ children, className, ...props }: CardContentProps) => (
  // Use Mantine Box to properly support spacing props like pt, p, etc.
  <Box className={className} {...props}>
    {children}
  </Box>
); 